import "core-js/modules/es.array.push.js";
import { createNamespacedHelpers } from "vuex";
const walletVuex = createNamespacedHelpers("wallet");
import loadConfig from "@Web3WalletConfig/config";
export default {
  name: "gift",
  computed: {
    ...walletVuex.mapState(["isMobile", "theme", 'setting'])
  },
  data() {
    return {
      loadConfig,
      isLock: false,
      list: [],
      popTaskShow: false,
      modifyData: {
        "icon": ""
      },
      isLoading: false,
      selectTab: 0,
      total: 0,
      condition: {
        page: 1,
        limit: 15,
        type: 'validate'
      },
      fixedTime: null
    };
  },
  methods: {
    async getData() {
      this.isLoading = true;
      let rs = await this.$http.post("/task/list", {
        status: this.selectTab == 0 ? 1 : 0,
        ...this.condition
      });
      this.isLoading = false;
      if (rs.code == 0) {
        this.list = rs.data.items;
        this.total = rs.data.total;
      }
    },
    async onCreate() {
      this.modifyData = {
        "icon": "",
        'status': "1",
        "type": 'telegram',
        'verifiable': "0",
        "limit_count": "0",
        "group_type": "1"
      };
      this.popTaskShow = true;
    },
    onSubTask(id) {
      this.$router.push("/subtask?id=" + id);
    },
    async onModify(item) {
      this.modifyData = item;
      this.popTaskShow = true;
    },
    cutStr(str) {
      if (str) return str.replace("T", " ").replace(".000Z", "");
    },
    onRefresh() {
      this.getData();
    },
    onPageChange(e) {
      this.condition.page = e;
      this.getData();
    },
    onPageSizeChange(e) {
      this.condition.limit = e;
      this.getData();
    },
    resetFixed() {
      clearTimeout(this.fixedTime);
      let list = this.$refs.fixed;
      if (list) {
        list.forEach((item, index) => {
          const rect = item.parentElement.getBoundingClientRect();
          // 计算父级元素距离页面顶部的距离
          const offsetTop = rect.top + window.scrollY;
          item.style.top = offsetTop + "px";
        });
      }
      this.fixedTime = setTimeout(() => {
        this.resetFixed();
      }, 1);
    }
  },
  mounted() {
    this.getData();
    this.resetFixed();
  },
  beforeDestroy() {
    clearTimeout(this.fixedTime);
  }
};